import { render, staticRenderFns } from "./StatsNewClients.vue?vue&type=template&id=b8063644&"
import script from "./StatsNewClients.vue?vue&type=script&lang=js&"
export * from "./StatsNewClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports